import { useCallback, useRef, useState } from 'react';
import { useDiscoveryContext } from '../context/DiscoveryContext';
import { sendChatMessage } from '../api/discoveryApi';

export function useStreamingChat(sessionId) {
  const { state, dispatch } = useDiscoveryContext();
  const [isLoading, setIsLoading] = useState(false);
  const messagesRef = useRef(state.messages);
  messagesRef.current = state.messages;

  const sendMessage = useCallback(
    async (content) => {
      if (!sessionId) return;
      const trimmed = typeof content === 'string' ? content.trim() : '';
      if (!trimmed) return;

      const nextMessages = [
        ...messagesRef.current,
        { role: 'user', content: trimmed },
      ];

      dispatch({ type: 'SEND_MESSAGE', payload: { content: trimmed } });
      dispatch({ type: 'CLEAR_SUGGESTIONS' });
      dispatch({ type: 'SET_STATUS', payload: 'loading' });
      setIsLoading(true);

      try {
        const result = await sendChatMessage(sessionId, nextMessages);
        const replyText =
          typeof result === 'string' ? result : (result?.message ?? '');
        const suggestions = Array.isArray(result?.suggestions)
          ? result.suggestions
          : [];
        dispatch({
          type: 'ADD_ASSISTANT_MESSAGE',
          payload: { content: replyText },
        });
        dispatch({ type: 'SET_SUGGESTIONS', payload: suggestions });
      } catch (err) {
        dispatch({ type: 'SET_ERROR', payload: err.message || 'Chat failed' });
      } finally {
        dispatch({ type: 'SET_STATUS', payload: 'idle' });
        setIsLoading(false);
      }
    },
    [sessionId, dispatch],
  );

  return { sendMessage, isLoading };
}
